<template>
  <div 
    class=" ">
    <v-layout wrap>
      <v-flex>
        <v-dialog v-model="dialog.success"
          width="350">
          <v-card 
            class="border-radius pa-2">
            <v-card-text>
              <v-img 
                width="125"
                height="125"
                alt="kominfoklaten" 
                :src="require('@/assets/icon/info_berhasil.png')"
                class="ma-auto my-6">
                <template v-slot:placeholder>
                  <v-row
                    class=" "
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      size="20"
                      indeterminate 
                      :color="set_color">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>

              <div
                class="body-1 text-center line-text-second">
                <div>
                  Terima kasih, password Anda
                </div>

                <div>
                  telah berhasil diubah!
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>

        <section>
          <v-card
            flat
            style="overflow-y: auto;">
            <v-card-text
              class="pt-8">
              <v-row>
                <v-col
                  cols="12"
                  md="6"
                  class="pt-0">
                  <ValidationProvider 
                    name="Currency" 
                    rules="required" 
                    v-slot="{ errors }">
                    <div class="fs-15 label-input">
                      <!-- <span class="red--text">*</span> -->

                      Currency
                    </div>

                    <v-text-field
                      v-on:keyup.enter="save()"
                      
                      filled
                      solo
                      rounded
                      dense
                      
                      :color="set_color"
                      placeholder="USD"

                      :disabled="Object.keys(form).length < 1"

                    

                      v-model="form.currency"
                      :error-messages="errors"
                      required
                      style="border-radius: 10px;">
                      <!-- <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>
                        
                        <div v-if="form.name !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template> -->
                    </v-text-field>
                  </ValidationProvider>
                </v-col>

                <v-col
                  cols="12"
                  md="6"
                  class="pt-0">
                  <ValidationProvider 
                    name="Time Zone" 
                    rules="required" 
                    v-slot="{ errors }">
                    <div class="fs-15 label-input">
                      <!-- <span class="red--text">*</span> -->

                      Time Zone
                    </div>

                    <v-text-field
                      v-on:keyup.enter="save()"
                      
                      filled
                      solo
                      rounded
                      dense
                      
                      :color="set_color"
                      placeholder="(GMT-12:00) International Date Line West"

                      :disabled="Object.keys(form).length < 1"

                    

                      v-model="form.time_zone"
                      :error-messages="errors"
                      required
                      style="border-radius: 10px;">
                      <!-- <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>
                        
                        <div v-if="form.name !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template> -->
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <div class="fs-17 font-weight-medium" style="color: #333B69;">
                Notification
              </div>

              <div>
                <v-switch
                  v-model="form.receive"
                  inset
                  color="#16DBCC"
                  hide-details
                >
                  <template v-slot:label>
                    <div class="fs-16 label-input">
                      I send or receive digita currency
                    </div>
                  </template>
                </v-switch>

                <v-switch
                  v-model="form.merchant"
                  inset
                  color="#16DBCC"
                  hide-details
                >
                  <template v-slot:label>
                    <div class="fs-16 label-input">
                      I receive merchant order                    
                    </div>
                  </template>
                </v-switch>

                <v-switch
                  v-model="form.recommendation"
                  inset
                  color="#16DBCC"
                  hide-details
                >
                  <template v-slot:label>
                    <div class="fs-16 label-input">
                      There are recommendation for my account                    
                    </div>
                  </template>
                </v-switch>
              </div>

              <div v-if="message.error.length > 0"
                class="text-center my-4 d-flex align-center">
                <div
                  class="error--text">
                  <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>
            <div class="text-right mb-4">
              <v-btn 
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                width="190"
                height="45"
                elevation="0"
                color="#6948c6"
                class="fs-16 white--text text-capitalize border-radius">
                Simpan
              </v-btn>
            </div>
          </v-card>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        dialog: {
          success: false
        },

        show: {
          old_password: false,
          new_password: false
        },

        form: {
          currency: '',
          time_zone: '',
          receive: true,
          merchant: false,
          recommendation: false
        },

        process: {
          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      
    },
    watch: {
      
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      
    },
    methods: {
      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.process.form = true

          // SAVE TO REST API
          // await post(`admin/profile_user/change_password`, {
          //   data: this.form
          // })
          // .then((response) => {
          //   let res = response.data

          //   this.process.form = false

          //   if (res.status === 200) {
          //     if (this.$refs.form) this.$refs.form.reset()

          //     this.form = {
          //       currency: '',
          //       time_zone: '',
          //       receive: true,
                    // merchant: false,
                    // recommendation: false
          //     }
              
          //     this.dialog.success = true
          //   } else {
          //     this.message.error = res.message
          //   }
          // })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>